import { render, staticRenderFns } from "./LogoPfscComponent.vue?vue&type=template&id=0deb74ae&scoped=true&"
import script from "./LogoPfscComponent.vue?vue&type=script&lang=ts&"
export * from "./LogoPfscComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb74ae",
  null
  
)

export default component.exports